import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PermissionDashboard } from '../components/permission';
import './PermissionsPage.css';

const PermissionsPage: React.FC = () => {
  const { documentId } = useParams<{ documentId?: string }>();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="page-container">
        <div className="page-header text-center">
          <h1 className="page-title">Access Denied</h1>
          <p className="page-subtitle">
            You need to be logged in to manage document permissions.
          </p>
        </div>
        <div className="d-flex justify-content-center">
          <div className="card" style={{ maxWidth: '400px', width: '100%' }}>
            <div className="card-body text-center">
              <div className="alert alert-warning">
                <h5>🔒 Authentication Required</h5>
                <p>Permission management is only available to registered users.</p>
              </div>
              <div className="auth-actions">
                <a href="/login" className="btn btn-primary">
                  Sign In
                </a>
                <a href="/register" className="btn btn-outline-primary">
                  Create Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="permissions-content">
        <PermissionDashboard
          documentId={documentId}
          className="main-dashboard"
        />
      </div>

      {/* Help Section */}
      <div className="help-section">
        <div className="card">
          <div className="card-body">
            <h6>📚 Permission Management Guide</h6>
            <div className="help-grid">
              <div className="help-item">
                <div className="help-icon">👁️</div>
                <div className="help-content">
                  <strong>View Permission</strong>
                  <p>Allows users to view document pages through the secure viewer</p>
                </div>
              </div>
              <div className="help-item">
                <div className="help-icon">⬇️</div>
                <div className="help-content">
                  <strong>Download Permission</strong>
                  <p>Enables users to download the complete document</p>
                </div>
              </div>
              <div className="help-item">
                <div className="help-icon">🖨️</div>
                <div className="help-content">
                  <strong>Print Permission</strong>
                  <p>Allows users to print the document or specific pages</p>
                </div>
              </div>
              <div className="help-item">
                <div className="help-icon">📄</div>
                <div className="help-content">
                  <strong>Page Restrictions</strong>
                  <p>Control access to specific pages or ranges (e.g., "1,3,5-10")</p>
                </div>
              </div>
            </div>
            
            <div className="security-note">
              <h6>🔒 Security Features</h6>
              <ul>
                <li><strong>Real-time Enforcement:</strong> Permission changes take effect immediately</li>
                <li><strong>Page-level Control:</strong> Restrict access to specific pages</li>
                <li><strong>Activity Tracking:</strong> Monitor who accesses your documents and when</li>
                <li><strong>Secure Streaming:</strong> Documents are served page-by-page with permission validation</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionsPage;